angular.module('tgaAdmin')
  .service('eventService', ['$http', 'envService', 'domainService',
    function ($http, envService, domainService) {
      const serverAddress = envService.read('serverAddress');

      function getEvent(eventId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}event/${eventId}`,
          params: {
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateEvent(data) {
        return $http({
          method: 'PUT',
          url: `${serverAddress}event`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        getEvent,
        updateEvent,
      });
    }]);
